export default "__VITE_ASSET__c41206b7__"